import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  SyncDataModalForReconnectingGoogleSheetContainer,
  type SyncDataModalForReconnectingGoogleSheetContainerProps,
} from './syncDataModalForReconnectingGoogleSheet.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ReconnectGoogleSheet: Omit<SyncDataModalForReconnectingGoogleSheetContainerProps, 'isOpen' | 'onClose'>;
  }
}

modalRenderer.register('ReconnectGoogleSheet', (props) => <SyncDataModalForReconnectingGoogleSheetContainer {...props} />);
